import { useEffect, useRef, useState } from "react";
import {FastAverageColor} from 'fast-average-color';

const ColoredBackImage = ({ url, blackMask, expandOnHover }) => {
    const imageRef = useRef(null);
    const [bgColor, setBgColor] = useState('#333');

    return (
        <div
            className={`w-full h-full flex items-center justify-center relative group`}
            style={{ backgroundColor: bgColor }}
        >
            <img
                ref={imageRef}
                src={url}
                alt="Image"
                className={`h-full min-w-fit group-hover:scale-125 transition-all duration-500`}
            />
            <div
                className={`absolute top-0 left-0 w-full h-full z-[1] bg-gray-800`}
                style={{ opacity: blackMask || 0 }}
            ></div>
        </div>
    );
};

export default ColoredBackImage;